<template>
  <div class="mb-3 p-3 soft-panel small">
    <p class="font-weight-medium mb-2">Invite Tradie to Company</p>
    <p class="text-muted mb-2">
      This invites the tradie to your company and adds them to this project.
      They'll appear on this timesheet once eligible (immediately on a free-tier
      company, or once your admin assigns them a token).
    </p>
    <b-form-row class="align-items-end">
      <b-col sm="4">
        <b-form-group label="Full name" class="mb-0">
          <b-form-input v-model="form.name" type="text" size="sm" />
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group label="Email" class="mb-0">
          <b-form-input v-model="form.email" type="email" size="sm" />
        </b-form-group>
      </b-col>
      <b-col sm="2" class="mt-3 mt-sm-0">
        <b-button
          variant="outline-primary"
          size="sm"
          :disabled="!form.name || !form.email || loading"
          @click="$emit('invite')"
        >
          Invite
        </b-button>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
export default {
  name: 'SupervisorInviteTradiePanel',
  props: {
    form: { type: Object, required: true },
    loading: { type: Boolean, default: false },
  },
}
</script>

<style lang="scss" scoped>
/* .soft-panel is also defined in SupervisorTimesheetTab.vue (used directly
   in its own template for the rejection-reason box), duplicated here rather
   than moved since both need it independently — see SupervisorAuditTrail.vue's
   comment for why a plain move doesn't work across components (commit 3d53908). */
.soft-panel {
  margin-bottom: 1rem;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  color: #374151;
}
</style>
